import React from 'react'

const Context = React.createContext({api:'amplifapi',userEmail:''})

export default Context;